import React from "react";
import Loader from "react-loader-spinner";
import themeConfiguration from "config/themeConfiguration";
import "./loader.scss";

const ReactLoader = (props) => {
  return (
    <span className={"loading-container"}>
      <Loader
        visible={typeof props.visible !== "undefined" ? props.visible : true}
        type={
          typeof props.type === "undefined"
            ? themeConfiguration.loader.type
            : props.type
        }
        color={
          typeof props.color !== "undefined"
            ? props.color
            : themeConfiguration.loader.color
        }
        secondaryColor={
          typeof props.secondaryColor !== "undefined"
            ? props.secondaryColor
            : themeConfiguration.loader.color
        }
        height={
          typeof props.height === "undefined"
            ? themeConfiguration.loader.height
            : props.height
        }
        width={
          typeof props.width === "undefined"
            ? themeConfiguration.loader.width
            : props.width
        }
        radius={
          typeof props.radius === "undefined"
            ? themeConfiguration.loader.radius
            : props.radius
        }
      />
    </span>
  );
};

export default ReactLoader;
